// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FormComponentPositionResponse } from './form-component-position-response';

// @ts-ignore
import { FormComponentResponse } from './form-component-response';

/** See com.rev360.pms.api.controller.encounter.dynamic.form.FormFieldResponse */
/* istanbul ignore next */
@GandalfModel
export class FormFieldResponse extends FormComponentResponse {

	@GandalfProperty({ designType: String })
	defaultNormal!: string | null;

	@GandalfProperty({ designType: String })
	defaultValue!: string | null;

	@GandalfProperty({ designType: Number })
	fieldId!: number | null;

	@GandalfConstantDecorator(constants.FieldDataType)
	@GandalfProperty({ designType: constants.FieldDataType })
	formFieldDataType!: constants.FieldDataType | null;

	@GandalfProperty({ designType: String })
	masterIdentifier!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: FormComponentPositionResponse })
	position!: FormComponentPositionResponse | null;

	@GandalfProperty({ designType: String })
	refractionName!: string | null;

	@GandalfProperty({ designType: Number })
	tabIndex!: number | null;

	@GandalfProperty({ designType: Number })
	uiComponentId!: number | null;

	@GandalfConstantDecorator(constants.FieldUIComponentType)
	@GandalfProperty({ designType: constants.FieldUIComponentType })
	uiComponentType!: constants.FieldUIComponentType | null;

}
